import { useQuery } from "@tanstack/react-query";
import { listBooks, type ListBooksParams } from "../api/client";
import { isTerminalStatus } from "../lib/stage";
import { queryKeys } from "./queryKeys";

/** Library list. Refetches every 5s while any book currently on screen is still non-terminal (§7 live updates). */
export function useBooks(params: ListBooksParams = {}) {
  return useQuery({
    queryKey: queryKeys.books(params),
    queryFn: () => listBooks(params),
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return false;
      const hasActive = data.books.some((b) => !isTerminalStatus(b.status));
      return hasActive ? 5000 : false;
    },
  });
}
